import { ReportData } from "model/reportData.model"
import { RestaurantOccupationReport } from "model/reports/restaurantOccupation.report.model"
import { toDateMonthYearHourMinuteString } from "utils/date.util"

export function createRestaurantOccupationReportData(data?: RestaurantOccupationReport[]): ReportData {
    const rows = data?.map(_ => {
        return [
            // _.building ?? '---' ,
            // _.area ?? '---' ,
            _.room ?? '---',
            toDateMonthYearHourMinuteString(_.date) ?? '---',
            _.value ?? '---'
        ]
    }) ?? []
    return {
        titles: [
            // 'Prédio', 
            // 'Andar', 
            'Restaurante', 
            'Data', 
            'Ocupação'
        ],
        rows: rows
    }
}